export default class RequestCommentType {
    static COMMENT = 0;
    static FIRST_COMMENT = 1;
}
